import type { OnInit } from '@angular/core';
import { Component, Input } from '@angular/core';
import { ColumnContext } from '@legacy/common-ui-shared-interfaces';
import { getIsExperienceEditorActive } from '@core/jss-routing';
import { getDroplinkValue, mockForXp } from '@core/jss-utils';
import { isNotNullOrEmptyString } from '@innogy/utils-deprecated';
import type {
  KlantenvertellenLocation,
  ReviewStatistics,
} from '@integration/reviews-api-models';
import { GetReviewsStatisticsQuery } from '@integration/reviews-api-models';
import { Store } from '@ngrx/store';

import { getReviewStatistics, selectReviewStatistics } from '../../+state';
import { mockStats } from '../../reviews.mocks';
import { ReviewsComponentRendering } from '../../reviews.model';

@Component({
  selector: 'wl-review-score-container[rendering]',
  templateUrl: './review-score-container.component.html',
  styleUrls: [],
})
export class ReviewScoreContainerComponent implements OnInit {
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() rendering?: ReviewsComponentRendering;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() context?: ColumnContext;

  constructor(private readonly store$: Store) {}

  xpEditorActive$ = this.store$.select(getIsExperienceEditorActive);

  stats$ = mockForXp<ReviewStatistics | undefined>(
    this.xpEditorActive$,
    this.store$.select(selectReviewStatistics),
    mockStats
  );

  get location() {
    const input = getDroplinkValue(this.rendering?.fields, 'reviewCategory');
    return isNotNullOrEmptyString(input) ? input : undefined;
  }

  ngOnInit(): void {
    this.store$.dispatch(
      getReviewStatistics({
        payload: GetReviewsStatisticsQuery.fromPlain({
          location: this.location as KlantenvertellenLocation,
        }),
      })
    );
  }
}
